import React from 'react'
import back from "../images/back.svg";
import { useEffect } from 'react';
export default function Navbar({title}) {

  const hadleClick=(e)=>{
    e.preventDefault();
    window.history.back();

  }
  useEffect(() => {
    const previousPage = document.referrer;
 
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      window.history.pushState(null, null, window.location.href);
    }
    return () => {
      window.onpopstate = null;
    };
  }, []);
  return (
    <div className='navbarcomponent'>
    {/* <img src={back} onClick={hadleClick}></img> */}
    <h1>{title}</h1>
    </div>
  )
}
